// iColumn/iRow gap takes a number or a size.spacing alias, NOT a raw "Npx" string
// (themeSpacing["64px"] is undefined → gap drops); the compile freezes alias→px.

function normalizeGapValue(value) {
  if (typeof value === "string") {
    const match = /^(-?\d+)px$/.exec(value);
    if (match) {
      return parseInt(match[1], 10);
    }
  }
  return value;
}

module.exports = normalizeGapValue;
module.exports.normalizeGapValue = normalizeGapValue;
